import { render, staticRenderFns } from "./titulosComponent.vue?vue&type=template&id=6bfde141&scoped=true&"
import script from "./titulosComponent.vue?vue&type=script&lang=js&"
export * from "./titulosComponent.vue?vue&type=script&lang=js&"
import style0 from "./titulosComponent.vue?vue&type=style&index=0&id=6bfde141&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfde141",
  null
  
)

export default component.exports